module.exports = __webpack_public_path__ + "media/icons/document-74fd14f0.png";